<template>
  <div class="text-center">
    <!--:href="`${root}/admin/promoterDashboard`"-->
    <a
      class="legacy-dashboard"
      target="_blank"
      rel="noopener noreferrer"
      @click="goToDashboard(`${root}/admin/promoterDashboard`)"
    >{{ $t("top-menu.all.legacy-dashboard") }}</a
    >
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="ma-2"
          style="max-height: 28px"
        >
          <i class="far fa-clipboard"></i>
          {{ $tc("top-menu.raceEdit.participants") }}
        </v-btn>
      </template>
      <v-list style="text-align: left">
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          style
          @click="goToUrl(item.url)"
        >
          <v-list-item-title>
            <i :class="item.icon"></i>
            {{ $tc(item.indexTitle) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="ma-2"
          style="max-height: 28px"
        >
          <i class="far fa-clock"></i>
          {{ $tc("top-menu.raceEdit.scores") }}
        </v-btn>
      </template>
      <v-list style="text-align: left">
        <v-list-item
          v-for="(item, index) in scores"
          :key="index"
          style
          @click="goToUrl(item.url)"
        >
          <v-list-item-title>
            <i :class="item.icon"></i>
            {{ $tc(item.indexTitle) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn small link class="ma-2" @click="changePage('back')">
      <i class="far fa-tags"></i>
      {{ $tc("top-menu.raceEdit.back") }}
    </v-btn>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      items: [
        {
          indexTitle: "top-menu.raceEdit.participantsItems.newParticipant",
          url: `/dashboard/raceDetails/${this.$route.params.id}/new-participant`,
          icon: "far fa-user-plus",
        },
        {
          indexTitle: "top-menu.raceEdit.participantsItems.participant-scores",
          url: `/dashboard/raceDetails/${this.$route.params.id}/participants-scores`,
          icon: "far fa-clock",
        },
        {
          indexTitle: "top-menu.raceEdit.participantsItems.deleteClass",
          url: `/dashboard/raceDetails/${this.$route.params.id}/delete-class-scores`,
          icon: "far fa-trash",
        },
      ],
      scores: [
        {
          indexTitle: "top-menu.raceEdit.results",
          url: `/dashboard/raceDetails/${this.$route.params.id}/results`,
          icon: "fas fa-flag-checkered",
        },
        {
          indexTitle: "top-menu.raceEdit.scoresItems.quickScore",
          url: `/dashboard/raceDetails/${this.$route.params.id}/quick-scores`,
          icon: "far fa-fire",
        },
        {
          indexTitle: "top-menu.raceEdit.scoresItems.addDnf",
          url: `/dashboard/raceDetails/${this.$route.params.id}/add-dnf-participants`,
          icon: "far fa-users",
        },
        {
          indexTitle: "top-menu.raceEdit.scoresItems.clearScores",
          url: `/dashboard/raceDetails/${this.$route.params.id}/clear-all-scores`,
          icon: "far fa-times-circle",
        },
        {
          indexTitle: "top-menu.raceEdit.scoresItems.importScore",
          url: `/dashboard/raceDetails/${this.$route.params.id}/import-scores-from-race`,
          icon: "far fa-downlraceDetailsoad",
        },
      ],
    };
  },
  computed: {
    ...mapState(["root"]),
    buttonsRaceEdit() {
      let items = [
        {
          title: this.$t("top-menu.all.dashboard"),
          icon: "far fa-tachometer",
          name: "PromoterDashboard",
        },
        {
          title: this.$t("top-menu.raceEdit.participants"),
          icon: "far fa-clipboard",
          name: false,
          items: [
            {
              indexTitle: "top-menu.raceEdit.participantsItems.newParticipant",
              icon: "far fa-user-plus",
              name: "NewParticipant"
            },
            {
              indexTitle: "top-menu.raceEdit.participantsItems.participant-scores",
              icon: "far fa-clock",
              name: "ParticipantScores"
            },
            {
              indexTitle: "top-menu.raceEdit.participantsItems.deleteClass",
              icon: "far fa-trash",
              name: "DeleteClassScore"
            },
          ]
        },
        {
          title: this.$t("top-menu.raceEdit.scores"),
          icon: "far fa-clock",
          name: false,
          items: [
            {
              indexTitle: "top-menu.raceEdit.scoresItems.quickScore",
              icon: "far fa-fire",
              name: "QuickScore"
            },
            {
              indexTitle: "top-menu.raceEdit.scoresItems.addDnf",
              icon: "far fa-users",
              name: "AddDNFParticipants"
            },
            {
              indexTitle: "top-menu.raceEdit.scoresItems.clearScores",
              icon: "far fa-times-circle",
              name: "ClearAllScores"
            },
            {
              indexTitle: "top-menu.raceEdit.scoresItems.importScore",
              icon: "far fa-downlraceDetailsoad",
              name: "ImportScoresFromRace"
            },
          ]
        },
        {
          title: this.$t("top-menu.raceEdit.back"),
          icon: "far fa-tags",
          name: "raceDetails",
        },
      ];
      //this.$emit('loadTopMenuResponsive',items);
      return items;
    },
    sectionsUpdated() {
      return this.$store.getters.getSectionsUpdate;
    },
    isChangesSections() {
      return (
        (this.$route.name == 'SectionEditor' || this.$route.name == 'SectionEditorOld') && 
        this.sectionsUpdated.length > 0
      );
    },
  },
  methods: {
    changePage(page) {
      var path;

      if (page == "dashBoard") path = `/dashBoard`;
      else if (page == "participants") path = `/dashBoard`;
      else if (page == "scores") path = `/dashBoard`;
      else if (page == "back") path = `/dashBoard/raceDetails/${this.$route.params.id}`;

      if (this.$route.path !== path)
        this.$router.push({
          path: path,
        });
    },
    goToUrl(url) {
      window.location = `#${url}`;
    },
    generateTopMenu: function (items) {
      let options = [];
      options = items.map((elem) => {
        let subitems = [];
        if(elem.items && Array.isArray(elem.items) &&  elem.items.length > 0) {
          subitems = elem.items.map((elem1) => {
            return {
              ...elem1,
              text: this.$t(elem1.indexTitle),
              lang: elem1.indexTitle
            };
          });
        } 
        
        return {
          ...elem,
          text: elem.title,
          items: subitems
        };
      });
      this.$emit("loadTopMenuResponsive", options);
    }, 
    isUrlVue(url) {
      return url.includes('/promoter/#/');
    },
    goToDashboard(url) {
      if(this.isChangesSections && !this.isUrlVue(url)) {
        this.$store.commit('setNextUrl',url);
        this.$store.commit('setActiveMessageConfirmation', true);
      } else {
        window.location.href = url;
      }
    }
  },
  mounted() {
    this.generateTopMenu(this.buttonsRaceEdit);
  }
};
</script>
<style>
.legacy-dashboard {
  text-align: right !important;
  text-align: -moz-right !important;
  text-decoration: underline !important;
  color: #0e152d !important;
  margin-right: 10px;
}
</style>
